module.exports = {"pt-BR":{"realEstate":{"cnab":{"index":{"menu":"Menu","remittance":"Remessa","return":"Retorno","cnab":"CNAB"}}}}}